module.exports = __webpack_public_path__ + "images/FUSA_icons/020-dollar.8cf360bfb43c43744dd8d734d4c9d07a.svg";